import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Button, message, Result, Tag, Typography } from "antd";
import Cookies from "universal-cookie";

import "./application.scss";

import {
  getTokenHeader,
  replaceUrlByParams,
  setTokenHeader,
} from "../../utils/api";
import { PAGE } from "../../utils/constants";
import { AppContext } from "../../App";
import { applicationResult } from "../../apis/result";
import {
  paymentMethodText,
  PaymentSelectDropdown,
} from "../../components/paymentStatusTemplate/paymentStatusTemplate";
import { alipay_success } from "../../apis/paymentGateway";

function ApplicationResultPage(props) {
  let location = useLocation();
  let htmlTitle,
    history = useHistory();
  const { pid } = useParams();
  const { appSetting } = useContext(AppContext);
  const { Title, Text, Paragraph } = Typography;
  const [result, setResult] = useState({
    result: [],
    payment: {},
  });
  htmlTitle = { __html: appSetting.applicationSuccessTitle };
  const { adminToken, userToken } = getTokenHeader();
  const cookies = new Cookies();

  useEffect(() => {
    // console.log('a', userToken, cookies.get('userToken'))
    if (props.location.state) {
      //on submit
      setResult(props.location.state.result);
      htmlTitle = { __html: appSetting.applicationSuccessTitle };
      setTokenHeader(adminToken, props.location.state.result.token);
    } else if (userToken || location.search) {
      // console.log('c', cookies.get('userToken'))
      if (location.search) {
        // console.log('is refresh or redirect back', cookies.get('userToken'))
        setTokenHeader(adminToken, cookies.get("userToken"));
        getAliSuccess();
      } else {
        getResult();
      }
    } else {
      history.replace(`${replaceUrlByParams(PAGE.LANDING, { ":pid": pid })}`);
    }
  }, [props]);

  const getResult = async () => {
    try {
      const res = await applicationResult();
      if (res.error) {
        message.error("操作無效，重新定向", 1, () =>
          history.replace(
            `${replaceUrlByParams(PAGE.LANDING, { ":pid": pid })}`
          )
        );
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setResult(res);
        cookies.set("userToken", "");
      }
    } catch (e) {
      console.error(e);
    }
  };
  const getAliSuccess = async () => {
    try {
      const res = await alipay_success(location.search.substring(1));
      if (res.error) {
        // message.error('操作無效，重新定向', 1, () => history.replace(`${replaceUrlByParams(PAGE.LANDING, {':pid':pid})}`))
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setResult(res);
        cookies.set("userToken", "");
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Result className="fit-height" status="success">
      <Title level={3}>
        <span
          className="text-area-description"
          dangerouslySetInnerHTML={htmlTitle}
        />
      </Title>

      <Text className="text-area-description">
        {appSetting.applicationSuccessDescription}
      </Text>
      <div className="application-info">
        {result.result.map((resultField, i) => {
          return (
            <Paragraph key={i} strong={true}>
              {resultField.name}: {resultField.value}
            </Paragraph>
          );
        })}
      </div>

      {result.payment && (
        <div className="flex-table">
          <div className="cell">
            <div className="label">付款金額</div>
            <div className="value">
              HKD {result.payment.paymentAmountInCents / 100}
            </div>
          </div>
          <div className="cell">
            <div className="label">付款狀態</div>
            <div className="value">
              <Tag
                color={result.payment.status === "paid" ? "success" : "warning"}
              >
                {result.payment.status === "paid" ? "已付款" : "待付款"}
              </Tag>
            </div>
          </div>
          {result.payment.paymentMethod && (
            <div className="cell">
              <div className="label">付款方式</div>
              <div className="value">
                {paymentMethodText(result.payment.paymentMethod)}
              </div>
            </div>
          )}
        </div>
      )}
      <div className="action-bar">
        <Button
          key="backToLanding"
          onClick={() =>
            history.push(`${replaceUrlByParams(PAGE.LANDING, { ":pid": pid })}`)
          }
        >
          回到主頁
        </Button>

        <Text key="or">或</Text>

        {appSetting.paymentEnabled && result.payment.status === "pending" ? (
          <PaymentSelectDropdown>
            <Button type="primary">線上付款</Button>
          </PaymentSelectDropdown>
        ) : (
          <Button
            type="primary"
            onClick={() =>
              history.push(
                `${replaceUrlByParams(PAGE.APPLICATION, { ":pid": pid })}`
              )
            }
            key="newSubmit"
          >
            遞交另一份申請
          </Button>
        )}
      </div>
    </Result>
  );
}

export default ApplicationResultPage;
